var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmitTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1654 8.3444C14.1666 9.15407 14.0079 9.956 13.6985 10.7042C13.389 11.4524 12.9349 12.1321 12.3621 12.7044C11.7891 13.2774 11.1089 13.7319 10.3602 14.0419C9.61152 14.3519 8.80909 14.5113 7.99876 14.5111C7.12661 14.5132 6.26404 14.3291 5.46876 13.9711L2.89076 14.3524C2.76276 14.3733 2.6316 14.3626 2.50865 14.3213C2.38571 14.28 2.27471 14.2093 2.1853 14.1154C2.09589 14.0214 2.03076 13.9071 1.99558 13.7822C1.9604 13.6574 1.95623 13.5259 1.98343 13.3991L2.34143 10.7837C2.00172 10.0156 1.82815 9.18431 1.8321 8.3444C1.83099 7.53475 1.98971 6.73283 2.29917 5.98465C2.60862 5.23646 3.06272 4.55672 3.63543 3.9844C4.20836 3.41135 4.88861 2.95683 5.6373 2.64683C6.38599 2.33683 7.18843 2.17743 7.99876 2.17773C9.63517 2.17784 11.2046 2.82767 12.3621 3.9844C12.9346 4.5569 13.3885 5.23667 13.698 5.98482C14.0074 6.73296 14.1662 7.53479 14.1654 8.3444Z",
    stroke: "#34343E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79455 5.55469V10.7514M5.19922 8.15869H10.4019",
    stroke: "#34343E",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitTicket);
export default __webpack_public_path__ + "static/media/submit-ticket.ac0c75fbb574ccad4764ea069f5174b8.svg";
export { ForwardRef as ReactComponent };